import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next';
import './style.css'
import TypeWriter from './TypingEffectMessage'
import Separator from '../Separator';

export default function Jumbotron(props) {

    let msgs = [ "Bem Vindo", "Welcome", "Bienvenue", "Willkommen", "Bienvenido" ];

    const {t} = useTranslation();

    const Div = styled.div`
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        height: ${props.height}vh;
        width: 100%;
        z-index: 2;
        position: relative;
        background-image: url('https://media1.giphy.com/media/jaOXKCxtBPLieRLI0c/giphy.gif');
        background-attachment: fixed;
        background-size: cover;
        background-position: center;
    `

    return (
        <>
            <Div>
                {typeof props.message == 'boolean' && <TypeWriter messages={msgs} />}
                {typeof props.message == 'string' && <Title>{t(props.message)}</Title>}
            </Div>
            <Separator nextColor={'#f0f2f5'} oldColor={'#f0f2f5'} jumbo={true}/>
        </>
    )
}


const Title = styled.h1`
    font-size: 40px;
    margin-top: 100px;
    text-align: center;
`